import styles from './styles.module.scss';
import illustration from '@svg/illustrations/suspended_modal.svg';
import Button from '@components/common/button';
import { useHelpCenterModals } from '@hooks/modals/useHelpCenterModals';
import { useLocales } from '@hooks/helpers/useLocales';

const SuspendedModal = () => {
    const { handleOpenSubmitRequestModal } = useHelpCenterModals();
    const { submitLocale } = useLocales();
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="success" />
            <div className={styles.title}>Your account is temporarily suspended</div>
            <div className={styles.description}>
                We've detected some unusual activity on your account. As a precaution, we’ve
                temporarily restricted access to certain services. To restore access, please contact
                our support team
            </div>
            <Button variant="primary" onClick={handleOpenSubmitRequestModal}>
                {submitLocale('contact_support')}
            </Button>
        </div>
    );
};

export default SuspendedModal;
